import * as React from 'react';

function PlaceholderRegistrationCertificateFrontPoland(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 359.33 225">
			<defs>
				<style>
					{
						'.cls-1{fill: #66849e;} .cls-2{fill: #99adbe;} .cls-3{fill: #ccdeed;} .cls-4, .cls-5 {fill: #335b7d;} .cls-5 {opacity: .72;}'
					}
				</style>
			</defs>
			<g id="Ebene_1" data-name="Ebene 1">
				<rect className="cls-3" width="359.33" height="225" />
			</g>
			<g id="Document_front_PL" data-name="Document front_PL">
				<path
					className="cls-1"
					d="m18.02,26.97h322.97c3.3,0,6.3,1.03,8.48,2.7h0s0,0,0,0c2.18,1.67,3.53,3.97,3.53,6.5v153.58c0,2.53-1.35,4.83-3.53,6.5h0c-2.18,1.67-5.18,2.71-8.49,2.71H18.02c-3.31,0-6.31-1.04-8.49-2.7h0c-2.18-1.68-3.53-3.98-3.53-6.51V36.18c0-2.54,1.35-4.84,3.53-6.51h.01c2.18-1.67,5.18-2.7,8.48-2.7h0Zm322.97,4.07H18.02c-1.85,0-3.52.58-4.74,1.51h0c-1.22.94-1.97,2.22-1.97,3.63v153.58c0,1.41.75,2.7,1.97,3.63h0c1.22.93,2.89,1.51,4.74,1.51h322.97c1.84,0,3.52-.58,4.74-1.51h.01c1.21-.93,1.96-2.21,1.96-3.63V36.18c0-1.42-.75-2.7-1.96-3.63h-.01c-1.21-.94-2.89-1.51-4.74-1.51h0Z"
				/>
				<polygon
					className="cls-1"
					points="131.24 38.09 186.43 38.09 186.43 42.11 131.24 42.11 131.24 38.09 131.24 38.09"
				/>
				<polygon
					className="cls-1"
					points="131.24 45.09 186.43 45.09 186.43 49.11 131.24 49.11 131.24 45.09 131.24 45.09"
				/>
				<polygon
					className="cls-1"
					points="142.24 58.09 194 58.09 194 61.65 142.24 61.65 142.24 58.09 142.24 58.09"
				/>
				<polygon
					className="cls-1"
					points="131.24 52.09 194 52.09 194 55.65 131.24 55.65 131.24 52.09 131.24 52.09"
				/>
				<polygon
					className="cls-1"
					points="246.24 92.33 308 92.33 308 95.69 246.24 95.69 246.24 92.33 246.24 92.33"
				/>
				<polygon
					className="cls-1"
					points="246.24 84.33 290 84.33 290 88.07 246.24 88.07 246.24 84.33 246.24 84.33"
				/>
				<polygon
					className="cls-1"
					points="246.24 76.33 290 76.33 290 80.07 246.24 80.07 246.24 76.33 246.24 76.33"
				/>
				<polygon
					className="cls-1"
					points="258.95 130.47 291 130.47 291 134.55 258.95 134.55 258.95 130.47 258.95 130.47"
				/>
				<polygon
					className="cls-1"
					points="258.95 136.47 291 136.47 291 140.55 258.95 140.55 258.95 136.47 258.95 136.47"
				/>
				<polygon
					className="cls-1"
					points="258.95 142.47 291 142.47 291 146.55 258.95 146.55 258.95 142.47 258.95 142.47"
				/>
				<polygon
					className="cls-1"
					points="283.95 118.47 316 118.47 316 122.55 283.95 122.55 283.95 118.47 283.95 118.47"
				/>
				<polygon
					className="cls-1"
					points="253 172.71 275 172.71 275 176.61 253 176.61 253 172.71 253 172.71"
				/>
				<polygon
					className="cls-1"
					points="156.06 118.47 174 118.47 174 122.49 156.06 122.49 156.06 118.47 156.06 118.47"
				/>
				<polygon
					className="cls-1"
					points="174.06 130.47 192 130.47 192 134.49 174.06 134.49 174.06 130.47 174.06 130.47"
				/>
				<polygon
					className="cls-1"
					points="141.06 107.47 159 107.47 159 111.49 141.06 111.49 141.06 107.47 141.06 107.47"
				/>
				<polygon
					className="cls-1"
					points="175.06 107.47 193 107.47 193 111.49 175.06 111.49 175.06 107.47 175.06 107.47"
				/>
				<polygon
					className="cls-1"
					points="209.06 107.47 227 107.47 227 111.49 209.06 111.49 209.06 107.47 209.06 107.47"
				/>
				<polygon
					className="cls-1"
					points="33.51 184.97 33.51 37.61 36.47 37.61 36.47 184.97 33.51 184.97 33.51 184.97"
				/>
				<polygon
					className="cls-1"
					points="26.51 184.97 26.51 37.61 29.47 37.61 29.47 184.97 26.51 184.97 26.51 184.97"
				/>
				<polygon
					className="cls-1"
					points="26.51 184.97 26.51 37.61 29.47 37.61 29.47 184.97 26.51 184.97 26.51 184.97"
				/>
				<polygon
					className="cls-1"
					points="20.51 184.97 20.51 37.61 23.47 37.61 23.47 184.97 20.51 184.97 20.51 184.97"
				/>
				<polygon
					className="cls-1"
					points="140.52 152.2 172 152.2 172 155.78 140.52 155.78 140.52 152.2 140.52 152.2"
				/>
				<polygon
					className="cls-1"
					points="76.52 119.2 108 119.2 108 122.78 76.52 122.78 76.52 119.2 76.52 119.2"
				/>
				<polygon
					className="cls-1"
					points="194.52 152.2 226 152.2 226 155.78 194.52 155.78 194.52 152.2 194.52 152.2"
				/>
				<path
					className="cls-5"
					d="m264.62,34.35h-20.08c-1.23,0-2.23,1-2.23,2.23v11.15c0,1.23,1,2.23,2.23,2.23h20.08c1.23,0,2.23-1,2.23-2.23v-11.15c0-1.23-1-2.23-2.23-2.23Zm-5.02,4.46l.23-.69.23.69h.71s-.5.38-.5.38l.14.74-.58-.42-.58.41.14-.73-.5-.38h.71Zm-11.8,2.97h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74-.58-.42-.58.41.14-.73-.5-.38Zm2.2,4.14l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Zm-.14-6.72l.14.74-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38Zm2.35,8.88l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Zm-.14-11.14l.14.74-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38Zm3.16,11.95l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Zm-.14-12.72l.14.74-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38Zm3.02,11.91l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Zm-.14-11.14l.14.74-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38Zm2.42,8.98l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Zm.76-3.01l-.58-.42-.58.41.14-.73-.5-.38h.71l.23-.69.23.69h.71s-.5.38-.5.38l.14.74Z"
				/>
				<polygon
					className="cls-1"
					points="131.24 70.09 186.43 70.09 186.43 74.11 131.24 74.11 131.24 70.09 131.24 70.09"
				/>
				<polygon
					className="cls-1"
					points="131.24 77.09 186.43 77.09 186.43 81.11 131.24 81.11 131.24 77.09 131.24 77.09"
				/>
				<polygon
					className="cls-1"
					points="142.24 90.09 194 90.09 194 93.65 142.24 93.65 142.24 90.09 142.24 90.09"
				/>
				<polygon
					className="cls-1"
					points="131.24 84.09 194 84.09 194 87.65 131.24 87.65 131.24 84.09 131.24 84.09"
				/>
				<polygon
					className="cls-1"
					points="284 172.67 306 172.67 306 176.57 284 176.57 284 172.67 284 172.67"
				/>
				<polygon
					className="cls-1"
					points="315 171.86 319 171.86 319 177.57 315 177.57 315 171.86 315 171.86"
				/>
				<polygon
					className="cls-1"
					points="247 171.86 251 171.86 251 177.57 247 177.57 247 171.86 247 171.86"
				/>
				<polygon
					className="cls-1"
					points="247 159.86 251 159.86 251 165.57 247 165.57 247 159.86 247 159.86"
				/>
				<polygon
					className="cls-1"
					points="247 148.86 251 148.86 251 154.57 247 154.57 247 148.86 247 148.86"
				/>
				<polygon
					className="cls-1"
					points="131 171.86 135 171.86 135 177.57 131 177.57 131 171.86 131 171.86"
				/>
				<polygon
					className="cls-1"
					points="131 159.86 135 159.86 135 165.57 131 165.57 131 159.86 131 159.86"
				/>
				<polygon
					className="cls-1"
					points="131 148.86 135 148.86 135 154.57 131 154.57 131 148.86 131 148.86"
				/>
				<polygon
					className="cls-1"
					points="131 138.86 135 138.86 135 144.57 131 144.57 131 138.86 131 138.86"
				/>
				<polygon
					className="cls-1"
					points="131 127.86 135 127.86 135 133.57 131 133.57 131 127.86 131 127.86"
				/>
				<polygon
					className="cls-1"
					points="131 116.86 135 116.86 135 122.57 131 122.57 131 116.86 131 116.86"
				/>
				<polygon
					className="cls-1"
					points="131 104.86 135 104.86 135 110.57 131 110.57 131 104.86 131 104.86"
				/>
				<polygon
					className="cls-1"
					points="200 104.86 204 104.86 204 110.57 200 110.57 200 104.86 200 104.86"
				/>
				<polygon
					className="cls-1"
					points="209.06 118.47 227 118.47 227 122.49 209.06 122.49 209.06 118.47 209.06 118.47"
				/>
				<polygon
					className="cls-1"
					points="200 115.86 204 115.86 204 121.57 200 121.57 200 115.86 200 115.86"
				/>
				<polygon
					className="cls-1"
					points="166 104.86 170 104.86 170 110.57 166 110.57 166 104.86 166 104.86"
				/>
				<polygon
					className="cls-1"
					points="200 138.86 204 138.86 204 144.57 200 144.57 200 138.86 200 138.86"
				/>
				<polygon
					className="cls-1"
					points="166 138.86 170 138.86 170 144.57 166 144.57 166 138.86 166 138.86"
				/>
				<polygon
					className="cls-1"
					points="184 160.86 188 160.86 188 166.57 184 166.57 184 160.86 184 160.86"
				/>
				<polygon
					className="cls-1"
					points="184 150.86 188 150.86 188 156.57 184 156.57 184 150.86 184 150.86"
				/>
				<polygon
					className="cls-1"
					points="184 171.86 188 171.86 188 177.57 184 177.57 184 171.86 184 171.86"
				/>
				<polygon
					className="cls-1"
					points="247 115.86 251.98 115.86 251.98 122.97 247 122.97 247 115.86 247 115.86"
				/>
				<polygon
					className="cls-1"
					points="131 93.86 135.98 93.86 135.98 100.97 131 100.97 131 93.86 131 93.86"
				/>
				<polygon
					className="cls-1"
					points="245.97 105.58 278.03 105.58 278.03 109.66 245.97 109.66 245.97 105.58 245.97 105.58"
				/>
				<polygon
					className="cls-1"
					points="262.97 160.58 311 160.58 311 165.45 262.97 165.45 262.97 160.58 262.97 160.58"
				/>
				<polygon
					className="cls-1"
					points="143.99 185.18 168 185.18 168 187.97 143.99 187.97 143.99 185.18 143.99 185.18"
				/>
				<polygon
					className="cls-1"
					points="171.99 185.2 196.01 185.2 196.01 189.94 171.99 189.94 171.99 185.2 171.99 185.2"
				/>
				<polygon
					className="cls-1"
					points="55.99 185.18 80 185.18 80 187.97 55.99 187.97 55.99 185.18 55.99 185.18"
				/>
				<polygon
					className="cls-1"
					points="83.99 185.2 108.01 185.2 108.01 189.94 83.99 189.94 83.99 185.2 83.99 185.2"
				/>
				<polygon
					className="cls-1"
					points="257.99 185.18 282 185.18 282 187.97 257.99 187.97 257.99 185.18 257.99 185.18"
				/>
				<polygon
					className="cls-1"
					points="285.99 185.2 310.01 185.2 310.01 189.94 285.99 189.94 285.99 185.2 285.99 185.2"
				/>
				<polygon
					className="cls-1"
					points="175.26 141.83 196 141.83 196 145.35 175.26 145.35 175.26 141.83 175.26 141.83"
				/>
				<polygon
					className="cls-1"
					points="140.26 141.83 161 141.83 161 145.35 140.26 145.35 140.26 141.83 140.26 141.83"
				/>
				<polygon
					className="cls-1"
					points="194.26 162.83 215 162.83 215 166.35 194.26 166.35 194.26 162.83 194.26 162.83"
				/>
				<polygon
					className="cls-1"
					points="150.26 162.83 171 162.83 171 166.35 150.26 166.35 150.26 162.83 150.26 162.83"
				/>
				<polygon
					className="cls-1"
					points="194.26 172.83 215 172.83 215 176.35 194.26 176.35 194.26 172.83 194.26 172.83"
				/>
				<polygon
					className="cls-1"
					points="150.26 172.83 171 172.83 171 176.35 150.26 176.35 150.26 172.83 150.26 172.83"
				/>
				<polygon
					className="cls-1"
					points="209.26 141.83 226 141.83 226 145.35 209.26 145.35 209.26 141.83 209.26 141.83"
				/>
				<path
					className="cls-4"
					d="m230.62,34.97v67.49h-88.62c.39.61,1.01,1.01,1.72,1.01h85.65c1.18,0,2.13-1.1,2.13-2.45V36.95c0-.82-.35-1.53-.88-1.98Z"
				/>
				<path
					className="cls-4"
					d="m116.87,57.97v22.17h-62.87c.28.2.72.33,1.22.33h60.77c.84,0,1.51-.36,1.51-.81v-21.04c0-.27-.25-.5-.63-.65Z"
				/>
				<path
					className="cls-4"
					d="m343.63,127.97v29.06h-87.63c.38.26,1,.44,1.7.44h84.69c1.16,0,2.11-.47,2.11-1.06v-27.59c0-.35-.35-.66-.87-.85Z"
				/>
				<path
					className="cls-4"
					d="m116.87,116.97v8.49h-62.87c.28.61.72,1.01,1.22,1.01h60.77c.84,0,1.51-1.1,1.51-2.45v-7.05h-.63Z"
				/>
				<path
					className="cls-4"
					d="m343.14,113.97v10.27h-86.14c.38.74.98,1.23,1.67,1.23h83.26c1.14,0,2.07-1.33,2.07-2.97v-7.53l-.86-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,127.97v8.49h-100.53c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m254.6,147.65l-.22-.26v8.96h-9.96l.26.22c.41.35.91.53,1.43.53h6.79c.52,0,1.01-.18,1.43-.53l.05-.04v.03l.1-.11.11-.1h-.03l.04-.05c.35-.41.53-.91.53-1.43v-5.79c0-.52-.18-1.01-.53-1.43Z"
				/>
				<path
					className="cls-4"
					d="m254.6,159.65l-.22-.26v8.96h-9.96l.26.22c.41.35.91.53,1.43.53h6.79c.52,0,1.01-.18,1.43-.53l.05-.04v.03l.1-.11.11-.1h-.03l.04-.05c.35-.41.53-.91.53-1.43v-5.79c0-.52-.18-1.01-.53-1.43Z"
				/>
				<path
					className="cls-4"
					d="m254.6,114.3l-.22-.33v11.19h-9.96l.26.28c.41.43.91.66,1.43.66h6.79c.52,0,1.01-.23,1.43-.66l.05-.06v.04l.1-.14.11-.12h-.03l.04-.07c.35-.51.53-1.13.53-1.78v-7.23c0-.65-.18-1.27-.53-1.78Z"
				/>
				<path
					className="cls-4"
					d="m139.6,94.24l-.22-.27v9.34h-9.96l.26.23c.41.36.91.55,1.43.55h6.79c.52,0,1.01-.19,1.43-.55l.05-.05v.04l.1-.12.11-.1h-.03l.04-.05c.35-.43.53-.94.53-1.49v-6.04c0-.54-.18-1.06-.53-1.49Z"
				/>
				<polygon
					className="cls-1"
					points="56 117.76 66.12 117.76 66.12 122.97 56 122.97 56 117.76 56 117.76"
				/>
				<polygon
					className="cls-1"
					points="76.52 107.2 108 107.2 108 110.78 76.52 110.78 76.52 107.2 76.52 107.2"
				/>
				<path
					className="cls-4"
					d="m116.87,104.97v8.49h-62.87c.28.61.72,1.01,1.22,1.01h60.77c.84,0,1.51-1.1,1.51-2.45v-6.05l-.63-1Z"
				/>
				<polygon
					className="cls-1"
					points="56 105.76 66.12 105.76 66.12 110.97 56 110.97 56 105.76 56 105.76"
				/>
				<polygon
					className="cls-1"
					points="76.52 96.2 108 96.2 108 99.78 76.52 99.78 76.52 96.2 76.52 96.2"
				/>
				<path
					className="cls-4"
					d="m116.87,93.97v8.49h-62.87c.28.61.72,1.01,1.22,1.01h60.77c.84,0,1.51-1.1,1.51-2.45v-6.05l-.63-1Z"
				/>
				<path
					className="cls-4"
					d="m343.64,159.97v8.49h-86.64c.38.61.99,1.01,1.68,1.01h83.73c1.15,0,2.08-1.1,2.08-2.45v-6.05l-.86-1Z"
				/>
				<polygon
					className="cls-1"
					points="56 94.76 66.12 94.76 66.12 99.97 56 99.97 56 94.76 56 94.76"
				/>
				<polygon
					className="cls-1"
					points="76.52 83.2 108 83.2 108 86.78 76.52 86.78 76.52 83.2 76.52 83.2"
				/>
				<path
					className="cls-4"
					d="m116.87,80.97v8.49h-62.87c.28.61.72,1.01,1.22,1.01h60.77c.84,0,1.51-1.1,1.51-2.45v-6.05l-.63-1Z"
				/>
				<polygon
					className="cls-1"
					points="56 81.76 66.12 81.76 66.12 86.97 56 86.97 56 81.76 56 81.76"
				/>
				<polygon
					className="cls-1"
					points="76.52 67.2 108 67.2 108 70.78 76.52 70.78 76.52 67.2 76.52 67.2"
				/>
				<polygon className="cls-1" points="54 57.76 74 57.76 74 62.97 54 62.97 54 57.76 54 57.76" />
				<path
					className="cls-4"
					d="m116.87,35.97v19.21h-62.87c.28.17.72.29,1.22.29h60.77c.84,0,1.51-.31,1.51-.7v-18.24c0-.23-.25-.44-.63-.56Z"
				/>
				<polygon
					className="cls-1"
					points="60.52 43.2 106 43.2 106 47.88 60.52 47.88 60.52 43.2 60.52 43.2"
				/>
				<polygon className="cls-1" points="54 35.76 74 35.76 74 40.97 54 40.97 54 35.76 54 35.76" />
				<path
					className="cls-4"
					d="m230.5,104.97v8.49h-31.5v-8.49l-1,1v7.49h-33.5v-8.49l-1,1v7.49h-33.53c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,115.97v8.49h-31.5v-8.49l-1,1v7.49h-68.03c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,138.97v8.49h-31.5v-8.49l-1,1v7.49h-33v-8.49l-1,1v7.49h-34.03c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,148.97v8.49h-49.5v-8.49l-1,1v7.49h-50.03c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,159.97v8.49h-49.5v-8.49l-1,1v7.49h-50.03c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m230.5,170.97v8.49h-49.5v-8.49l-1,1v7.49h-50.03c.44.61,1.15,1.01,1.95,1.01h97.16c1.34,0,2.42-1.1,2.42-2.45v-6.05l-1-1Z"
				/>
				<path
					className="cls-4"
					d="m343.51,170.97v8.49h-30.51v-8.49l-1,1v7.49h-33v-8.49l-1,1v7.49h-34c.44.61,1.14,1.01,1.93,1.01h96.17c1.32,0,2.39-1.1,2.39-1.45v-7.05l-.99-1Z"
				/>
				<g>
					<polygon
						className="cls-4"
						points="71.08 131.65 70.15 131.65 70.15 132.57 70.15 133.5 71.08 133.5 72 133.5 72 132.57 71.08 132.57 71.08 131.65"
					/>
					<polygon
						className="cls-4"
						points="91.38 132.57 91.38 131.65 90.46 131.65 89.54 131.65 89.54 132.57 90.46 132.57 91.38 132.57"
					/>
					<polygon
						className="cls-4"
						points="93.23 132.57 94.15 132.57 94.15 133.5 95.08 133.5 95.08 132.57 95.08 131.65 94.15 131.65 93.23 131.65 92.31 131.65 92.31 132.57 92.31 133.5 93.23 133.5 93.23 132.57"
					/>
					<rect className="cls-4" x="91.38" y="133.5" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="71.08 134.42 70.15 134.42 70.15 135.34 70.15 136.27 71.08 136.27 71.08 135.34 71.08 134.42"
					/>
					<rect className="cls-4" x="71.08" y="136.27" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="71.08 138.11 70.15 138.11 70.15 139.03 71.08 139.03 72 139.03 72 138.11 71.08 138.11"
					/>
					<polygon
						className="cls-4"
						points="75.69 140.88 74.77 140.88 74.77 141.8 74.77 142.73 75.69 142.73 75.69 141.8 76.62 141.8 76.62 142.73 77.54 142.73 77.54 141.8 77.54 140.88 76.62 140.88 75.69 140.88"
					/>
					<polygon
						className="cls-4"
						points="68.31 142.73 69.23 142.73 70.15 142.73 70.15 141.8 69.23 141.8 68.31 141.8 67.38 141.8 66.46 141.8 66.46 142.73 66.46 143.65 67.38 143.65 67.38 142.73 68.31 142.73"
					/>
					<rect className="cls-4" x="78.46" y="141.8" width=".92" height=".92" />
					<rect className="cls-4" x="99.69" y="141.8" width=".92" height=".92" />
					<rect className="cls-4" x="101.54" y="141.8" width=".92" height=".92" />
					<rect className="cls-4" x="103.38" y="141.8" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="60.92 142.73 60.92 141.8 60 141.8 60 142.73 60 143.65 60.92 143.65 60.92 142.73"
					/>
					<path
						className="cls-4"
						d="m85.85,143.65h.92v.92h-.92v.92h-.92v.92h.92v.92h1.85v1.85h-.92v.92h2.77v1.85h.92v.92h.92v-2.77h-.92v-.92h-.92v-.92h1.85v-.92h-2.77v-.92h-1.85v-.92h.92v-.92h.92v1.85h2.77v.92h.92v-2.77h-.92v-.92h.92v-1.85h-.92v.92h-.92v.92h-.92v-.92h-.92v-.92h.92v.92h.92v-1.85h3.69v-.92h.92v1.85h-.92v.92h-.92v6.46h.92v-.92h.92v-1.85h-.92v-2.77h.92v-.92h1.85v-.92h-.92v-.92h.92v-.92h.92v-3.69h-.92v.92h-.92v-.92h.92v-.92h.92v-3.69h-.92v.92h-.92v.92h.92v.92h-.92v-.92h-.92v.92h-.92v-.92h-.92v.92h-.92v.92h.92v.92h-.92v-.92h-.92v.92h-.92v1.85h.92v-.92h3.69v.92h1.85v.92h-1.85v-.92h-.92v.92h-1.85v-.92h-.92v1.85h-.92v-.92h-2.77v.92h.92v.92h-.92v1.85h-2.77v.92h.92Zm3.69.92h.92v.92h-.92v-.92Zm5.54-8.31h-.92v-.92h.92v.92Z"
					/>
					<path
						className="cls-4"
						d="m84.92,142.73v-.88h1.93v-4.65h.84v.92h.92v-.92h.92v-1.85h.92v-.92h-.92v-.92h-.92v.92h-.92v.92h-.92v-.92h.92v-.92h.92v-1.85h-.92v.92h-.92v-.92h-2.77v1.85h-.92v-1.85h-.92v.92h-.92v-.92h-.92v.92h-.92v-.92h-.92v.92h-.92v-.92h-.92v.92h-.92v-.92h-3.69v.92h.92v1.85h1.85v-.92h-.92v-.92h.92v.92h.92v.92h.92v-.92h.92v.92h1.85v-.92h.92v.92h-.92v.92h-1.85v-.92h-.92v.92h-.92v-.92h-.92v1.85h-.92v-.92h-1.85v.92h.92v.92h-.92v.92h.92v.92h.92v.92h-.92v-.92h-.92v1.85h2.77v-1.85h.92v.92h1.85v.92h2.77v-.92h.91v1.85h-.91v.92h.92v-.88h1.85v.88h1.85Zm-10.15-4.62h-.92v-.92h.92v.92Zm10.15-5.54h.92v.92h-.92v-.92Zm-.92,1.85h.92v.92h-.92v-.92Zm-2.77,1.85h-.92v.92h-.92v.92h.92v.92h-1.85v-.92h-2.77v-.92h.92v-.92h3.69v-.92h.92v.92Zm0-1.85v-.92h.92v.92h.92v.92h-.92v-.92h-.92Zm1.02,6.43v-3.61h3.61v3.61h-3.61Z"
					/>
					<polygon
						className="cls-4"
						points="74.77 144.57 74.77 143.65 73.85 143.65 73.85 142.73 72.92 142.73 72.92 141.8 72 141.8 71.08 141.8 71.08 142.73 72 142.73 72 143.65 72.92 143.65 72.92 144.57 73.85 144.57 74.77 144.57"
					/>
					<rect className="cls-4" x="84" y="143.65" width=".92" height=".92" />
					<rect className="cls-4" x="95.08" y="143.65" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="96.92 144.57 97.85 144.57 97.85 145.5 98.77 145.5 98.77 144.57 98.77 143.65 97.85 143.65 97.85 142.73 96.92 142.73 96.92 143.65 96.92 144.57"
					/>
					<polygon
						className="cls-4"
						points="61.85 145.5 62.77 145.5 63.69 145.5 63.69 146.42 64.62 146.42 65.54 146.42 65.54 145.5 64.62 145.5 64.62 144.57 64.62 143.65 65.54 143.65 65.54 142.73 65.54 141.8 64.62 141.8 64.62 142.73 63.69 142.73 62.77 142.73 62.77 141.8 61.85 141.8 61.85 142.73 61.85 143.65 62.77 143.65 63.69 143.65 63.69 144.57 62.77 144.57 61.85 144.57 60.92 144.57 60 144.57 60 145.5 60 146.42 60.92 146.42 60.92 145.5 61.85 145.5"
					/>
					<polygon
						className="cls-4"
						points="68.31 144.57 68.31 143.65 67.38 143.65 67.38 144.57 66.46 144.57 66.46 145.5 66.46 146.42 67.38 146.42 68.31 146.42 68.31 145.5 68.31 144.57"
					/>
					<path
						className="cls-4"
						d="m75.69,145.5v1.85h.92v.92h-.92v.92h.92v.92h1.85v.92h-.92v.92h2.77v-.92h1.85v1.84h-.92v-.92h-.92v.92h.91v.92h-.91v-.92h-.92v.92h-.92v-.92h-.92v-.92h-1.85v-2.77h-1.85v.92h-.92v1.85h-.92v1.85h.92v.92h2.77v-.92h-1.85v-1.85h.92v.92h.92v.92h.92v.92h-.92v2.77h.92v-.92h.92v.92h-.92v.92h-1.85v-2.77h-.92v3.69h.92v.92h-.92v.92h2.77v-.92h.92v.92h.92v-.92h3.83v.92h.65v1.85h.92v-1.85h-.65v-.92h2.81v-.92h-1.88v-.88h2.72v-.97h.84v-1.85h.92v-.92h-.92v-.92h-.84v-.92h.84v-.92h-.92v.92h-.92v-.92h.92v-.92h-1.85v-1.85h-1.85v.92h-2.77v-.92h-1.85v-.92h1.85v.92h.92v-1.85h-.92v-.92h.92v-.92h-.92v-.92h-1.85v1.85h.92v.92h-1.85v-2.77h-.92v-.92h-.92v.92h-.92v.92h.92Zm2.77,13.85h-.92v-.92h.92v.92Zm0-2.77v-.92h.92v.92h-.92Zm1.85,2.77h-.92v-1.85h.92v-2.77h.91v4.62s-.91,0-.91,0Zm2.9,0h-.92v-.88h.92v.88Zm-.13-7.38v-.92h.92v.92h.92v.92h-1.85v-.92Zm-.82,1.91h3.59v1.78s.02,1.82.02,1.82h-3.61v-3.61Z"
					/>
					<polygon
						className="cls-4"
						points="81.23 145.5 82.15 145.5 82.15 144.57 83.08 144.57 83.08 143.65 83.08 142.73 82.15 142.73 82.15 143.65 81.23 143.65 80.31 143.65 80.31 144.57 81.23 144.57 81.23 145.5"
					/>
					<rect className="cls-4" x="83.08" y="144.57" width=".92" height=".92" />
					<rect className="cls-4" x="96" y="144.57" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="74.77 146.42 74.77 145.5 73.85 145.5 72.92 145.5 72.92 146.42 73.85 146.42 74.77 146.42"
					/>
					<rect className="cls-4" x="98.77" y="145.5" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="102.46 145.5 103.38 145.5 103.38 144.57 102.46 144.57 102.46 143.65 101.54 143.65 101.54 142.73 100.62 142.73 100.62 143.65 99.69 143.65 99.69 144.57 100.62 144.57 100.62 145.5 101.54 145.5 101.54 146.42 102.46 146.42 102.46 145.5"
					/>
					<polygon
						className="cls-4"
						points="82.15 148.27 83.08 148.27 84 148.27 84.92 148.27 85.85 148.27 85.85 147.34 84.92 147.34 84.92 146.42 84 146.42 84 147.34 83.08 147.34 83.08 146.42 83.08 145.5 82.15 145.5 82.15 146.42 81.23 146.42 81.23 147.34 82.15 147.34 82.15 148.27"
					/>
					<polygon
						className="cls-4"
						points="98.77 147.34 98.77 146.42 97.85 146.42 96.92 146.42 96 146.42 96 147.34 96.92 147.34 97.85 147.34 97.85 148.27 98.77 148.27 99.69 148.27 99.69 149.19 99.69 150.11 100.62 150.11 100.62 149.19 100.62 148.27 101.54 148.27 102.46 148.27 102.46 147.34 101.54 147.34 101.54 146.42 100.62 146.42 99.69 146.42 99.69 147.34 98.77 147.34"
					/>
					<polygon
						className="cls-4"
						points="73.85 148.27 74.77 148.27 74.77 147.34 73.85 147.34 72.92 147.34 72.92 148.27 72.92 149.19 73.85 149.19 73.85 148.27"
					/>
					<polygon
						className="cls-4"
						points="96 148.27 95.08 148.27 95.08 149.19 95.08 150.11 95.08 151.03 96 151.03 96 150.11 96 149.19 96.92 149.19 96.92 148.27 96 148.27"
					/>
					<polygon
						className="cls-4"
						points="93.23 150.11 92.31 150.11 92.31 151.03 93.23 151.03 94.15 151.03 94.15 150.11 93.23 150.11"
					/>
					<rect className="cls-4" x="70.15" y="151.03" width=".92" height=".92" />
					<rect className="cls-4" x="92.31" y="151.96" width=".92" height=".92" />
					<rect className="cls-4" x="63.69" y="152.88" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="95.08 163.03 96 163.03 96.92 163.03 97.85 163.03 97.85 162.11 96.92 162.11 96.92 161.19 96 161.19 96 162.11 95.08 162.11 94.15 162.11 94.15 163.03 95.08 163.03"
					/>
					<polygon
						className="cls-4"
						points="90.46 156.57 90.46 155.65 90.46 154.73 91.38 154.73 92.31 154.73 92.31 153.8 91.38 153.8 90.46 153.8 89.54 153.8 89.54 152.88 89.54 151.96 88.62 151.96 88.62 152.88 87.69 152.88 87.69 153.8 88.62 153.8 88.62 154.73 89.54 154.73 89.54 155.65 89.54 156.57 88.62 156.57 88.62 157.5 87.69 157.5 87.69 158.42 88.62 158.42 89.54 158.42 90.46 158.42 90.46 157.5 90.46 156.57"
					/>
					<rect className="cls-4" x="102.46" y="158.42" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="101.54 161.19 101.5 161.19 101.5 160.27 101.5 159.34 100.58 159.34 99.65 159.34 98.73 159.34 97.85 159.34 97.81 159.34 96.92 159.34 96.92 160.27 96.92 161.19 97.85 161.19 97.85 160.27 98.73 160.27 98.73 161.19 99.65 161.19 100.58 161.19 100.62 161.19 100.62 162.11 99.69 162.11 99.69 163.03 99.69 163.96 99.69 164.88 100.62 164.88 101.54 164.88 101.54 163.96 100.62 163.96 100.62 163.03 101.54 163.03 101.54 162.11 101.54 161.19"
					/>
					<polygon
						className="cls-4"
						points="64.62 162.11 64.62 161.19 63.69 161.19 62.77 161.19 62.77 162.11 63.69 162.11 63.69 163.03 64.62 163.03 64.62 162.11"
					/>
					<polygon
						className="cls-4"
						points="76.62 163.03 77.54 163.03 77.54 162.11 77.54 161.19 76.62 161.19 76.62 162.11 76.62 163.03"
					/>
					<rect className="cls-4" x="104.31" y="162.11" width=".92" height=".92" />
					<rect className="cls-4" x="76.62" y="163.96" width=".92" height=".92" />
					<rect className="cls-4" x="87.69" y="163.96" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="93.23 163.96 92.31 163.96 91.38 163.96 91.38 164.88 92.31 164.88 92.31 165.8 93.23 165.8 94.15 165.8 94.15 164.88 93.23 164.88 93.23 163.96"
					/>
					<rect className="cls-4" x="94.15" y="163.96" width=".92" height=".92" />
					<rect className="cls-4" x="60" y="167.65" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="66.46 167.65 66.46 168.57 67.38 168.57 67.38 169.5 68.31 169.5 69.23 169.5 69.23 168.57 68.31 168.57 68.31 167.65 67.38 167.65 66.46 167.65"
					/>
					<path
						className="cls-4"
						d="m99.69,167.65v.92h-.92v.88h-.92v-.88h-.92v-.92h2.77v-2.77h-1.85v-.92h-1.85v.92h-.92v1.85h-3.69v.92h.92v.92h-.92v-.92h-1.85v.92h.92v.92h-.92v.92h-.92v-.92h.92v-.92h-1.85v-1.85h.92v.92h.92v-.92h.92v-.92h-2.77v-.92h-.92v-.92h-.9v-.92h.9v.92h.92v-.92h.92v.92h.92v.92h.92v-1.85h-.92v-.92h-.92v-.92h.92v-.92h.92v-.92h-3.69v1.85h.92v.92h-2.91v1.85s0,.92,0,.92h-.78v-.92h-2.91v-.92h.92v-.92h-2.63v-.92h-.92v1.85h1.71v1.85h-.78v-.92h-.92v1.85h-1.85v-.92h-.92v.92h-.92v-.92h.92v-.92h-.92v-.92h.92v-.92h-1.85v2.77h-.92v-.92h-.92v.92h-1.85v-1.85h-.92v.92h-.92v-.92h-.92v3.69h.92v.92h1.85v2.77h.92v.92h.92v-.92h.92v-.92h-1.85v-2.77h-.92v-.92h.92v.92h.92v-.92h1.85v.92h-1.85v1.85h.92v-.92h.92v.92h-.92v.92h.92v.92h.92v.92h-1.85v.92h.92v.92h-1.85v-.92h-1.85v.92h.92v.92h-.92v5.54h2.77v-.92h.92v.92h.92v-1.85h-2.77v.92h-.92v-.92h.92v-.92h-.92v-1.85h1.85v-.92h.92v.92h.92v-1.85h1.85v.92h-.92v.92h.92v.92h.92v.92h-.92v.92h.92v.92h-.92v.92h3.69v-.92h-.92v-1.85h-.92v-.92h.92v.92h1.85v.92h-.92v.92h.92v.92h1.85v-1.85h-.92v-1.85h-1.85v-4.62h.96v3.71h4.58v.91h.92v.92h-.92v.92h.92v.92h-.92v.92h3.69v-.92h-.92v-1.85h-.92v-.92h.92v.92h1.85v.92h-.92v.92h.92v.92h1.85v-1.85h-.92v-3.69h-.92v-.92h-1.85v.92h.92v.92h.92v.92h-.92v-.92h-.92v-.92h-.92v.92h-.84v-4.62h.84v1.85h.92v-.92h.92v.92h.92v-1.85h.92v-.92h.92v.92h-.92v.92h.92v.92h-.92v.92h.92v1.85h.92v.92h-.92v.92h.92v1.85h.92v.92h.92v-1.85h.92v-.92h-.92v-.92h-.92v-.92h.92v.92h.92v.92h.92v.92h1.85v1.85h.92v-1.85h.92v1.85h1.85v-1.85h-.92v-1.85h-.92v.92h-.92v-.92h-2.77v-.91h5.53v-5.59h-.91v-1.81h-1.85Zm-2.77-1.85h1.85v.92h-1.85v-.92Zm-27.69,0h-.92v-.92h.92v.92Zm12.92-.92h.92v.92h-.92v-.92Zm-1.85.92v-.92h.92v1.85h-.92v-.92Zm-3.69,1.85h.92v-.92h1.85v.92h-1.85v.92h.92v.92h-.92v-.92h-.92v-.92Zm-1.85-.92h.92v.92h-.92v-.92Zm4.62,7.38v.92h-1.85v-1.85h1.85v.92Zm0-2.77h-.92v.92h-1.85v-.92h-.92v-1.85h-.92v-.92h.92v.92h.92v1.85h.92v-.92h1.85v.92Zm2.87,2.71v-3.61h3.59v.89s.02,2.71.02,2.71h-3.61Zm4.51-4.6h-.92v-.88h.92v.88Zm0-1.81h-1.85v.92h-.92v.88h-2.74v.96h-.96v-.92h-.92v-.92h1.85v-.92h.92v-.92h.92v.92h-.92v.92h1.85v-2.77h.92v-.92h.92v1.85h.92v.92Zm7.38,6.46h-.92v-.92h.92v.92Zm0-2.77v.92h-.92v-.92h.92v-.92h-.92v-.92h.92v-1.85h1.85v.92h-.92v.92h-.92v.92h.92v.92h-.92Zm2.7,2.77h-.86v-.92h-.92v-.92h.92v.92h.86v.92Zm0-3.69h-.86v-.92h.86v.92Zm4.6,3.64h-3.61v-3.61h3.61v3.61Z"
					/>
					<polygon
						className="cls-4"
						points="106.15 144.57 106.15 145.5 106.15 146.42 107.08 146.42 107.08 145.5 108 145.5 108 144.57 107.08 144.57 106.15 144.57"
					/>
					<path
						className="cls-4"
						d="m107.08,148.27v.92h-.92v-.92h-.92v-4.62h1.85v-1.85h-.92v.92h-1.85v3.69h-.92v1.85h.92v.92h-.92v-.92h-.92v.92h-.92v1.85h-1.85v-.92h-.92v-.92h-1.85v2.77h-.92v.92h.86v.92h-1.78v-2.77h-.92v2.77h-.92v1.85h2.77v-.92h.86v1.85h-3.63v.92h-.92v-.92h.92v-.92h-1.85v2.77h-.92v.92h.92v.92h.92v.92h-.92v-.92h-.92v.92h-.92v.92h.92v.92h1.85v-.92h1.85v-.92h1.85v-.92h-1.85v-.92h.92v-.92h-.92v-.92h.92v.92h1.78s5.63,0,5.63,0v-2.77h1.82v-.92h-.92v-1.85h-.9s-.02-.92-.02-.92h.92v-.92h-.92v-.92h.92v.92h.92v.92h-.92v.92h.92v.92h2.77v.92h-1.85v1.85h-1.85v1.85h1.85v.92h-1.85v.92h.92v.92h.92v.92h.92v.92h.92v1.85h-1.85v-.92h-.92v-.92h-.92v-.92h.92v-.92h-1.85v1.85h-.92v.92h.92v1.85h.92v-.92h.92v.92h-.92v.92h-.92v-.92h-.92v1.85h.92v.92h4.62v-.92h-2.77v-.92h1.85v-.92h.92v.92h.92v-4.62h-.92v-1.85h.92v-3.69h-.92v-.92h.92v-3.69h-.92v-.92h-1.85v-.92h1.85v.92h.92v-4.62h-.92v1.85Zm-13.85,11.08h-.92v-.92h.92v.92Zm4.62-7.38h2.77v.88h-2.77v-.88Zm3.61,5.48h-3.61v-3.61h3.61v3.61Zm5.62,1.91h-.92v-.92h.92v.92Z"
					/>
					<rect className="cls-4" x="107.08" y="169.5" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="104.31 171.34 104.31 170.42 104.31 169.5 103.38 169.5 103.38 170.42 103.38 171.34 103.38 172.27 104.31 172.27 104.31 171.34"
					/>
					<polygon
						className="cls-4"
						points="73.85 175.03 72.92 175.03 72.92 175.96 72.92 176.88 73.85 176.88 74.77 176.88 74.77 175.96 73.85 175.96 73.85 175.03"
					/>
					<rect className="cls-4" x="74.77" y="175.03" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="104.31 175.03 105.23 175.03 105.23 174.11 105.23 173.19 104.31 173.19 103.38 173.19 103.38 174.11 103.38 175.03 103.38 175.96 104.31 175.96 104.31 175.03"
					/>
					<rect className="cls-4" x="102.46" y="175.96" width=".92" height=".92" />
					<rect className="cls-4" x="103.38" y="176.88" width=".92" height=".92" />
					<rect className="cls-4" x="75.69" y="177.8" width=".92" height=".92" />
					<polygon
						className="cls-4"
						points="96 178.73 96 179.65 96.92 179.65 96.92 178.73 96.92 177.8 96 177.8 96 178.73"
					/>
					<polygon
						className="cls-4"
						points="106.15 172.27 106.15 171.34 106.15 170.42 106.15 169.5 105.23 169.5 105.23 170.42 105.23 171.34 105.23 172.27 105.23 173.19 106.15 173.19 107.08 173.19 107.08 174.11 106.15 174.11 106.15 175.03 105.23 175.03 105.23 175.96 106.15 175.96 106.15 176.88 105.23 176.88 105.23 177.8 104.31 177.8 104.31 178.73 105.23 178.73 106.15 178.73 106.15 179.65 107.08 179.65 108 179.65 108 178.73 107.08 178.73 107.08 177.8 108 177.8 108 176.88 107.08 176.88 107.08 175.96 107.08 175.03 108 175.03 108 174.11 108 173.19 108 172.27 107.08 172.27 106.15 172.27"
					/>
					<polygon
						className="cls-4"
						points="84.92 177.8 84.92 176.88 84.92 175.96 84 175.96 83.08 175.96 83.08 176.88 84 176.88 84 177.8 84 178.73 84.92 178.73 85.85 178.73 85.85 177.8 84.92 177.8"
					/>
					<rect className="cls-4" x="103.38" y="178.73" width=".92" height=".92" />
					<rect className="cls-4" x="66.46" y="162.11" width=".92" height=".92" />
					<rect className="cls-4" x="68.31" y="162.11" width=".92" height=".92" />
					<rect className="cls-4" x="70.15" y="162.11" width=".92" height=".92" />
					<path
						className="cls-4"
						d="m65.54,163.96h-1.85v-.92h-1.85v-.92h-.92v-1.85h1.85v-.92h-.92v-1.85h.92v-.92h.92v.92h-.92v.92h.92v1.85h1.85v.92h.92v-.92h.92v1.85h.92v-2.77h-.92v-.91h1.85v1.84h2.77v.92h-.92v.92h.92v.92h.92v-5.54h-.92v-.92h.92v-1.85h-.92v.92h-.86v-.92h.86v-.92h-.86v-.97h-.99v-.88h-.92v.88h-.92v-1.8h1.85v-1.85h.92v.92h1.85v-.92h-.92v-1.85h.92v-.92h-.92v-.92h.92v-.92h-1.85v3.69h-.92v-4.62h-.92v2.77h-.92v1.85h.92v.92h-.92v.92h-1.85v1.85h.92v.88h-.92v-.88h-.92v.92s.01,5.55.01,5.55h.91v.91h-.92v-.92h-.92v-2.77h-.92v-1.85h-.92v.92h-.92v-1.85h1.85v-.92h1.85v-.92h-1.85v-.92h.92v-.92h-.92v-.92h.92v.92h3.69v-.92h-.92v-.92h-4.62v.92h-.92v-.92h.92v-.92h-1.85v2.77h-.92v.92h.92v.92h.92v.92h-.92v-.92h-.92v2.77h.92v.92h-.92v3.69h.92v.92h-.92v3.69h.92v1.85h-.92v.92h.92v.92h.92v.92h.92v.92h-.92v.92h1.85v-.92h1.85v-1.85h.92v-.92h-1.85v1.85h-.92v-.92h-.92v-.92h-.92v-1.85h.92v.92h.92v.92h.92v-.92h1.85v-1.85h-.92v.92Zm1-10.13h3.61v3.61h-3.61v-3.61Zm-4.7-4.64h.92v.92h-.92v-.92Zm-.92,6.46h.92v.92h-.92v-.92Z"
					/>
					<rect className="cls-4" x="71.08" y="163.03" width=".92" height=".92" />
					<rect className="cls-4" x="99.16" y="171.76" width=".99" height=".99" />
					<rect className="cls-4" x="99.16" y="155.14" width=".99" height=".99" />
					<rect className="cls-4" x="67.85" y="155.14" width=".99" height=".99" />
					<rect className="cls-4" x="83.56" y="171.76" width=".99" height=".99" />
					<rect className="cls-4" x="83.56" y="155.17" width=".99" height=".99" />
					<rect className="cls-4" x="83.56" y="138.55" width=".99" height=".99" />
					<path
						className="cls-4"
						d="m69.23,131.59h-9.23v9.23h9.23v-9.23Zm-.92,8.31h-7.38v-7.38h7.38v7.38Z"
					/>
					<rect className="cls-4" x="62.62" y="134.2" width="4" height="4" />
					<path
						className="cls-4"
						d="m60,179.71h9.23v-9.23h-9.23v9.23Zm.92-8.31h7.38v7.38h-7.38v-7.38Z"
					/>
					<rect className="cls-4" x="62.62" y="173.1" width="4" height="4" />
					<path
						className="cls-4"
						d="m98.77,131.59v9.23h9.23v-9.23h-9.23Zm8.31,8.31h-7.38v-7.38h7.38v7.38Z"
					/>
					<rect className="cls-4" x="101.38" y="134.2" width="4" height="4" />
				</g>
				<g>
					<path
						className="cls-4"
						d="m272.03,35.99c-.35.05-.4.09-.54.5-.17.5-.57,1.77-.84,2.67h-.17c-.26-.78-.6-1.75-.86-2.49-.29.86-.59,1.72-.85,2.49h-.17c-.25-.86-.54-1.8-.81-2.67-.13-.41-.18-.46-.51-.5v-.14h1.24v.14c-.37.04-.38.1-.31.35.2.68.4,1.34.6,2.05.28-.8.58-1.67.83-2.49h.16c.28.85.56,1.64.85,2.49.21-.67.5-1.56.61-1.99.08-.29.04-.36-.39-.41v-.14h1.15v.14Z"
					/>
					<path
						className="cls-4"
						d="m274.78,36.61c-.08-.33-.23-.66-.7-.66-.39,0-.53.29-.53.55,0,.35.22.52.64.74.6.31.86.54.86,1.02,0,.53-.46.93-1.1.93-.3,0-.56-.08-.77-.17-.04-.14-.1-.48-.13-.75l.16-.04c.1.34.32.77.84.77.36,0,.58-.25.58-.58,0-.39-.21-.54-.65-.78-.53-.29-.82-.53-.82-.99s.37-.87,1.03-.87c.28,0,.56.08.66.1.02.18.04.38.08.71l-.16.03Z"
					/>
					<path
						className="cls-4"
						d="m277.57,35.85c.36,0,.64.06.85.21.2.15.33.38.33.71,0,.73-.62,1.03-1.1,1.03-.06,0-.11,0-.14-.01l-.34-.09v.78c0,.42.04.43.5.48v.14h-1.38v-.14c.43-.04.45-.08.45-.49v-1.99c0-.45-.06-.46-.45-.5v-.14h1.29Zm-.41,1.68c.06.03.2.06.37.06.33,0,.75-.17.75-.8,0-.55-.36-.77-.78-.77-.14,0-.25.02-.28.06-.04.04-.05.1-.05.23v1.22Z"
					/>
					<path
						className="cls-4"
						d="m281.75,35.78c.86,0,1.62.66,1.62,1.65,0,1.08-.73,1.75-1.65,1.75s-1.66-.73-1.66-1.67.64-1.73,1.69-1.73Zm-.1.19c-.56,0-1.07.47-1.07,1.41s.51,1.62,1.22,1.62c.61,0,1.06-.45,1.06-1.42,0-1.05-.56-1.61-1.21-1.61Zm-.21-.56l.83-.77c.11.02.31.2.36.27v.04s-1.09.58-1.09.58l-.1-.12Z"
					/>
					<path
						className="cls-4"
						d="m287.16,38.27c-.03.16-.18.68-.23.83h-2.33v-.14c.46-.04.5-.07.5-.5v-1.99c0-.43-.05-.45-.45-.49v-.14h1.34v.14c-.4.04-.46.06-.46.49v2.04c0,.31.04.38.33.38,0,0,.37,0,.4,0,.25,0,.33-.03.45-.16.12-.13.23-.33.31-.52l.15.04Z"
					/>
					<path
						className="cls-4"
						d="m291.74,35.99c-.32.04-.43.09-.44.32,0,.16-.01.37-.01.84v2.01h-.19l-2.14-2.62v1.25c0,.45.02.68.03.82,0,.26.13.33.5.36v.14h-1.22v-.14c.31-.02.43-.1.45-.35.02-.16.03-.39.03-.84v-1.28c0-.14,0-.22-.1-.33-.09-.13-.2-.16-.45-.18v-.14h.75l2.12,2.52v-1.23c0-.47,0-.68-.03-.83-.01-.23-.13-.29-.53-.32v-.14h1.24v.14Z"
					/>
					<path
						className="cls-4"
						d="m294.61,35.78c.86,0,1.62.66,1.62,1.65,0,1.08-.73,1.75-1.65,1.75s-1.66-.73-1.66-1.67.64-1.73,1.69-1.73Zm-.1.19c-.56,0-1.07.47-1.07,1.41s.51,1.62,1.22,1.62c.61,0,1.06-.45,1.06-1.42,0-1.05-.56-1.61-1.21-1.61Z"
					/>
					<path
						className="cls-4"
						d="m300.12,36.64c-.05-.16-.11-.33-.16-.42-.08-.14-.13-.17-.41-.17h-.5v2.44c0,.39.04.45.52.48v.14h-1.46v-.14c.47-.03.51-.08.51-.48v-2.44h-.46c-.28,0-.36.03-.44.18-.06.1-.1.22-.17.41h-.15c.03-.31.06-.62.08-.9h.11c.08.12.13.12.27.12h1.98c.14,0,.18-.02.25-.12h.12c0,.24.02.6.04.89l-.15.02Z"
					/>
					<path
						className="cls-4"
						d="m302.89,39.1v-.14c.33-.04.37-.09.29-.28-.06-.2-.17-.45-.27-.76h-1.08c-.08.23-.15.42-.22.63-.11.33-.04.37.37.42v.14h-1.16v-.14c.32-.04.4-.08.57-.53l1.04-2.63.16-.03c.32.86.66,1.8.98,2.67.16.44.21.48.56.52v.14h-1.24Zm-.5-2.67c-.16.43-.33.89-.48,1.28h.94l-.46-1.28Z"
					/>
					<path
						className="cls-4"
						d="m309.6,38.31c-.03.13-.17.65-.22.8h-2.43v-.14c.47-.04.5-.08.5-.49v-1.98c0-.45-.06-.47-.43-.51v-.14h1.53c.47,0,.67,0,.73-.01,0,.12.02.5.04.77l-.15.02c-.04-.17-.1-.27-.15-.38-.08-.17-.2-.2-.5-.2h-.48c-.16,0-.17.01-.17.16v1.11h.56c.38,0,.4-.08.46-.42h.16v1.03h-.16c-.07-.36-.1-.41-.47-.41h-.55v1c0,.35.11.38.36.39h.46c.31,0,.36-.04.47-.18.09-.1.2-.31.27-.46l.15.04Z"
					/>
					<path
						className="cls-4"
						d="m314.16,35.99c-.32.02-.43.1-.44.33,0,.12-.01.33-.01.79v.54c0,.51-.06.9-.35,1.21-.24.25-.58.32-.92.32-.29,0-.6-.06-.82-.23-.3-.23-.45-.58-.45-1.16v-1.28c0-.45-.04-.48-.44-.52v-.14h1.32v.14c-.4.03-.44.07-.44.52v1.25c0,.73.35,1.13.95,1.13.71,0,.94-.44.94-1.27v-.51c0-.46-.01-.65-.03-.79-.01-.23-.13-.31-.5-.33v-.14h1.2v.14Z"
					/>
					<path
						className="cls-4"
						d="m318.2,39.14c-.07,0-.12,0-.19,0-.37-.03-.56-.12-.78-.43-.19-.26-.37-.57-.53-.83-.1-.16-.17-.19-.42-.19h-.17v.79c0,.43.05.45.46.49v.14h-1.34v-.14c.42-.04.45-.06.45-.49v-2c0-.43-.06-.44-.45-.49v-.14h1.28c.37,0,.61.04.8.17.21.13.34.36.34.66,0,.43-.28.7-.65.86.09.16.3.49.46.72.19.27.28.39.4.52.14.15.25.2.37.23l-.02.14Zm-1.85-1.63c.26,0,.42-.04.55-.15.2-.15.28-.35.28-.62,0-.54-.36-.73-.74-.73-.15,0-.23.02-.27.05-.04.03-.06.08-.06.22v1.23h.24Z"
					/>
					<path
						className="cls-4"
						d="m320.85,35.78c.86,0,1.62.66,1.62,1.65,0,1.08-.73,1.75-1.65,1.75s-1.66-.73-1.66-1.67.64-1.73,1.69-1.73Zm-.1.19c-.56,0-1.07.47-1.07,1.41s.51,1.62,1.22,1.62c.61,0,1.06-.45,1.06-1.42,0-1.05-.56-1.61-1.21-1.61Z"
					/>
					<path
						className="cls-4"
						d="m325.04,35.85c.36,0,.64.06.85.21.2.15.33.38.33.71,0,.73-.62,1.03-1.1,1.03-.06,0-.11,0-.14-.01l-.34-.09v.78c0,.42.04.43.5.48v.14h-1.38v-.14c.43-.04.45-.08.45-.49v-1.99c0-.45-.05-.46-.45-.5v-.14h1.29Zm-.41,1.68c.06.03.2.06.37.06.33,0,.75-.17.75-.8,0-.55-.36-.77-.78-.77-.15,0-.25.02-.28.06-.04.04-.05.1-.05.23v1.22Z"
					/>
					<path
						className="cls-4"
						d="m330.03,38.31c-.03.13-.17.65-.22.8h-2.43v-.14c.47-.04.5-.08.5-.49v-1.98c0-.45-.06-.47-.43-.51v-.14h1.53c.47,0,.67,0,.73-.01,0,.12.02.5.04.77l-.15.02c-.04-.17-.1-.27-.15-.38-.08-.17-.2-.2-.5-.2h-.48c-.16,0-.17.01-.17.16v1.11h.56c.38,0,.4-.08.46-.42h.16v1.03h-.16c-.07-.36-.1-.41-.47-.41h-.55v1c0,.35.11.38.36.39h.46c.31,0,.36-.04.47-.18.09-.1.2-.31.27-.46l.15.04Z"
					/>
					<path
						className="cls-4"
						d="m332.48,35.99c-.39.05-.43.08-.43.5v1.85c0,.66-.11,1.01-.44,1.31-.17.15-.33.23-.47.29l-.08-.15c.29-.14.45-.37.5-.66.04-.24.05-.53.05-.95v-1.69c0-.42-.04-.46-.46-.5v-.14h1.32v.14Z"
					/>
					<path
						className="cls-4"
						d="m335.34,36.61c-.08-.33-.23-.66-.7-.66-.39,0-.53.29-.53.55,0,.35.22.52.63.74.6.31.86.54.86,1.02,0,.53-.46.93-1.1.93-.3,0-.56-.08-.77-.17-.04-.14-.1-.48-.13-.75l.16-.04c.1.34.32.77.84.77.36,0,.58-.25.58-.58,0-.39-.21-.54-.65-.78-.53-.29-.82-.53-.82-.99s.37-.87,1.03-.87c.28,0,.56.08.66.1.02.18.04.38.08.71l-.16.03Z"
					/>
					<path
						className="cls-4"
						d="m336.84,35.85h1.34v.14c-.39.04-.46.07-.46.52v.86c.1,0,.21-.09.36-.23.28-.27.62-.61.85-.87.15-.17.13-.23-.08-.27l-.14-.02v-.14h1.22v.14c-.38.05-.5.07-.84.42-.15.15-.54.53-.86.84.38.45.94,1.09,1.2,1.37.25.27.32.31.63.35v.14h-.8c-.39-.44-.79-.92-1.25-1.45-.11-.14-.2-.15-.28-.15v.95c0,.44.04.47.46.51v.14h-1.34v-.14c.41-.04.45-.07.45-.51v-1.95c0-.45-.04-.49-.45-.52v-.14Z"
					/>
					<path
						className="cls-4"
						d="m342.83,39.1v-.14c.33-.04.37-.09.29-.28-.06-.2-.17-.45-.27-.76h-1.08c-.08.23-.15.42-.22.63-.11.33-.04.37.37.42v.14h-1.16v-.14c.32-.04.4-.08.57-.53l1.04-2.63.16-.03c.32.86.66,1.8.98,2.67.16.44.21.48.56.52v.14h-1.24Zm-.5-2.67c-.16.43-.33.89-.48,1.28h.94l-.46-1.28Z"
					/>
				</g>
				<g>
					<path
						className="cls-4"
						d="m270.55,44.14h-.23c-.6-.03-.76-.14-.93-.41-.17-.27-.33-.55-.49-.86-.11-.21-.19-.27-.36-.27h-.08v.88c0,.42.03.46.4.54v.08h-1.41v-.08c.37-.08.4-.11.4-.54v-2.02c0-.42-.03-.48-.4-.54v-.08h1.35c.41,0,.66.04.87.19.19.13.3.34.3.59,0,.51-.38.73-.63.84.07.14.34.6.48.82.19.31.25.41.37.54.12.14.18.18.38.25v.07Zm-1.99-1.65c.24,0,.42-.02.54-.14.14-.13.2-.31.2-.6,0-.58-.29-.79-.58-.79-.11,0-.18.01-.21.04-.03.02-.05.06-.05.16v1.33h.1Z"
					/>
					<path
						className="cls-4"
						d="m274.44,43.29c-.04.17-.13.58-.19.81h-2.61l-.04-.04c.66-1.01,1.31-2.06,1.93-3.06h-.92c-.37,0-.44.06-.56.26-.07.1-.12.22-.17.35h-.09c.03-.23.08-.66.1-.87h.06c.09.1.13.11.31.11h2.03v.04c-.62,1.01-1.33,2.17-1.88,3.05.12,0,.61,0,.93,0s.5-.03.65-.16c.11-.09.25-.29.35-.52l.08.02Z"
					/>
					<path
						className="cls-4"
						d="m278.16,43.32c-.03.18-.12.67-.15.79h-2.44v-.08c.43-.06.47-.08.47-.53v-2.03c0-.45-.03-.49-.38-.53v-.08h1.52c.49,0,.69,0,.73-.01,0,.19.03.51.05.73l-.08.02c-.04-.12-.1-.31-.21-.44-.09-.11-.2-.14-.5-.14h-.38c-.1,0-.12.02-.12.12v1.2h.49c.4,0,.41-.11.48-.42h.08v.99h-.08c-.07-.3-.08-.42-.48-.42h-.49v1.07c0,.35.08.42.39.42h.29c.3,0,.37-.04.49-.17.09-.1.17-.27.25-.48l.08.02Z"
					/>
					<path
						className="cls-4"
						d="m282.32,43.3c-.05.21-.17.61-.24.76-.12.02-.52.12-.85.12-1.3,0-1.85-.81-1.85-1.69,0-.99.73-1.71,1.91-1.71.4,0,.77.09.89.1.01.26.05.56.07.77l-.09.02c-.1-.36-.23-.55-.51-.68-.13-.06-.28-.09-.49-.09-.75,0-1.07.67-1.07,1.5,0,.97.45,1.66,1.19,1.66.47,0,.74-.28.96-.78l.08.03Z"
					/>
					<path
						className="cls-4"
						d="m286.36,43.29c-.04.17-.13.58-.19.81h-2.61l-.04-.04c.66-1.01,1.31-2.06,1.93-3.06h-.92c-.37,0-.44.06-.56.26-.07.1-.12.22-.17.35h-.09c.03-.23.08-.66.1-.87h.06c.09.1.13.11.31.11h2.03v.04c-.62,1.01-1.33,2.17-1.88,3.05.12,0,.61,0,.93,0s.5-.03.65-.16c.11-.09.25-.29.35-.52l.08.02Z"
					/>
					<path
						className="cls-4"
						d="m289.3,40.78c.89,0,1.63.7,1.63,1.67,0,1.05-.74,1.73-1.64,1.73-.97,0-1.66-.75-1.66-1.68,0-.86.62-1.72,1.68-1.72Zm-.1.12c-.49,0-.86.49-.86,1.48,0,.94.38,1.67,1.03,1.67.5,0,.84-.51.84-1.48,0-1.05-.39-1.67-1.01-1.67Z"
					/>
					<path
						className="cls-4"
						d="m294.02,41.56c-.11-.42-.35-.67-.73-.67-.3,0-.47.21-.47.53s.17.47.61.72.82.53.82,1.05c0,.58-.49.99-1.15.99-.25,0-.48-.05-.75-.12-.03-.1-.11-.69-.11-.77l.08-.02c.11.44.41.79.87.79.35,0,.5-.24.5-.57,0-.32-.19-.54-.54-.76-.45-.28-.82-.53-.82-1.04s.41-.92,1.07-.92c.3,0,.53.06.64.06.02.19.05.46.08.7l-.08.02Z"
					/>
					<path
						className="cls-4"
						d="m296.78,40.85c.4,0,.67.07.85.2.24.16.36.39.36.7,0,.72-.63,1.02-1.13,1.02-.02,0-.06,0-.09,0l-.3-.06v.8c0,.45.05.48.44.54v.08h-1.46v-.08c.37-.06.4-.09.4-.54v-2.02c0-.45-.04-.48-.4-.54v-.08h1.33Zm-.31,1.74c.06.02.16.03.27.03.15,0,.59-.08.59-.86,0-.6-.26-.79-.61-.79-.09,0-.17.02-.19.04-.05.03-.05.08-.05.16v1.43Z"
					/>
					<path
						className="cls-4"
						d="m300.99,40.78c.89,0,1.63.7,1.63,1.67,0,1.05-.74,1.73-1.64,1.73-.97,0-1.66-.75-1.66-1.68,0-.86.62-1.72,1.68-1.72Zm-.1.12c-.49,0-.86.49-.86,1.48,0,.94.38,1.67,1.03,1.67.5,0,.84-.51.84-1.48,0-1.05-.39-1.67-1.01-1.67Z"
					/>
					<path
						className="cls-4"
						d="m306.39,43.29c-.04.23-.18.74-.21.82h-2.37v-.08c.44-.06.47-.1.47-.54v-2.02c0-.45-.04-.47-.42-.54v-.08h1.45v.08c-.38.07-.41.1-.41.54v2.14c0,.32.08.35.34.35h.3c.27,0,.34-.04.47-.16.11-.1.22-.32.31-.53l.07.02Z"
					/>
					<path
						className="cls-4"
						d="m307.48,44.1v-.08c.38-.06.4-.1.4-.57v-1.97c0-.47-.04-.51-.4-.56v-.08h1.43v.08c-.37.06-.41.09-.41.56v1.96c0,.48.03.51.41.57v.08h-1.43Z"
					/>
					<path
						className="cls-4"
						d="m312.88,41.59c-.06-.19-.09-.33-.22-.48-.08-.1-.14-.12-.4-.12h-.41v2.49c0,.43.05.47.44.54v.08h-1.48v-.08c.37-.08.42-.1.42-.54v-2.49h-.46c-.21,0-.28.06-.34.13-.08.1-.17.28-.23.48h-.08c.03-.27.05-.61.06-.86h.07c.08.11.17.11.31.11h2.01c.13,0,.21-.02.31-.11h.06c0,.23,0,.59.03.84h-.08Z"
					/>
					<path
						className="cls-4"
						d="m315.63,44.1v-.08c.34-.08.35-.13.26-.39-.06-.17-.15-.43-.25-.71h-.92c-.08.23-.17.46-.23.64-.12.34-.08.38.36.46v.08h-1.09v-.08c.33-.06.4-.12.57-.57l1.04-2.64.14-.02c.31.89.64,1.76.97,2.63.17.48.22.53.53.6v.08h-1.39Zm-.44-2.46c-.16.42-.27.76-.41,1.13h.8l-.38-1.13Z"
					/>
					<path
						className="cls-4"
						d="m322.81,40.85c.4,0,.67.07.85.2.24.16.36.39.36.7,0,.72-.63,1.02-1.13,1.02-.02,0-.06,0-.09,0l-.3-.06v.8c0,.45.05.48.44.54v.08h-1.46v-.08c.37-.06.4-.09.4-.54v-2.02c0-.45-.04-.48-.4-.54v-.08h1.33Zm-.31,1.74c.06.02.16.03.27.03.15,0,.59-.08.59-.86,0-.6-.26-.79-.61-.79-.09,0-.17.02-.19.04-.05.03-.05.08-.05.16v1.43Z"
					/>
					<path
						className="cls-4"
						d="m327.02,40.78c.89,0,1.63.7,1.63,1.67,0,1.05-.74,1.73-1.64,1.73-.97,0-1.66-.75-1.66-1.68,0-.86.62-1.72,1.68-1.72Zm-.1.12c-.49,0-.86.49-.86,1.48,0,.94.38,1.67,1.03,1.67.5,0,.84-.51.84-1.48,0-1.05-.4-1.67-1.01-1.67Z"
					/>
					<path
						className="cls-4"
						d="m332.42,43.29c-.04.23-.18.74-.21.82h-2.37v-.08c.44-.06.47-.1.47-.54v-2.02c0-.45-.04-.47-.42-.54v-.08h1.45v.08c-.38.07-.41.1-.41.54v2.14c0,.32.08.35.34.35h.3c.27,0,.34-.04.47-.16.11-.1.22-.32.31-.53l.07.02Z"
					/>
					<path
						className="cls-4"
						d="m335.42,41.56c-.11-.42-.35-.67-.73-.67-.3,0-.47.21-.47.53s.17.47.61.72c.43.26.82.53.82,1.05,0,.58-.49.99-1.15.99-.25,0-.48-.05-.76-.12-.03-.1-.1-.69-.11-.77l.08-.02c.11.44.41.79.87.79.35,0,.5-.24.5-.57,0-.32-.19-.54-.54-.76-.45-.28-.82-.53-.82-1.04s.41-.92,1.07-.92c.3,0,.53.06.63.06.02.19.05.46.09.7l-.08.02Z"
					/>
					<path
						className="cls-4"
						d="m336.84,40.85h1.42v.08c-.37.07-.41.1-.41.54v.92c.06-.02.15-.08.24-.17.36-.32.7-.7.94-.98.16-.19.14-.22-.14-.29l-.11-.02v-.08h1.17v.08c-.38.06-.49.11-.72.34-.29.29-.58.57-.87.88.34.47.76,1.02,1.14,1.46.26.31.36.37.6.41v.08h-1c-.29-.39-.78-1.03-1.05-1.4-.11-.15-.16-.21-.2-.23v1c0,.44.04.47.41.54v.08h-1.42v-.08c.35-.06.4-.1.4-.54v-2.01c0-.44-.04-.48-.4-.54v-.08Z"
					/>
					<path
						className="cls-4"
						d="m342.74,44.1v-.08c.35-.08.35-.13.26-.39-.06-.17-.15-.43-.25-.71h-.92c-.08.23-.17.46-.23.64-.12.34-.08.38.36.46v.08h-1.09v-.08c.33-.06.4-.12.57-.57l1.04-2.64.14-.02c.32.89.64,1.76.97,2.63.17.48.23.53.53.6v.08h-1.39Zm-.43-2.46c-.16.42-.27.76-.41,1.13h.8l-.38-1.13Z"
					/>
				</g>
				<g>
					<path
						className="cls-4"
						d="m268.62,45.85c.71,0,1.15.14,1.46.44.25.24.43.59.43,1.07,0,.59-.24,1.06-.63,1.35-.38.29-.87.4-1.48.4h-1.17v-.14c.43-.04.45-.08.45-.49v-2c0-.43-.06-.45-.45-.49v-.14h1.39Zm-.5,2.59c0,.38.16.48.54.48.9,0,1.36-.62,1.36-1.49,0-.55-.19-.96-.58-1.2-.23-.15-.52-.2-.86-.2-.22,0-.34.03-.4.07-.04.03-.06.08-.06.28v2.06Z"
					/>
					<path
						className="cls-4"
						d="m273.87,46.85c.62,0,1.09.48,1.09,1.12,0,.81-.6,1.2-1.09,1.2-.69,0-1.11-.56-1.11-1.12,0-.82.64-1.2,1.11-1.2Zm-.06.17c-.31,0-.58.29-.58.88,0,.64.28,1.1.69,1.1.31,0,.57-.23.57-.91,0-.59-.24-1.06-.68-1.06Z"
					/>
					<path
						className="cls-4"
						d="m280.42,47.04c-.25.04-.3.1-.41.38-.14.39-.38,1.08-.6,1.74h-.16c-.2-.54-.41-1.06-.6-1.57-.18.46-.41,1.02-.61,1.57h-.15c-.18-.6-.37-1.19-.58-1.79-.09-.27-.14-.3-.38-.33v-.14h1.04v.14c-.3.05-.32.08-.25.31.12.39.25.8.37,1.17.2-.51.4-1.03.6-1.59h.14c.18.52.39,1.06.6,1.6.11-.31.27-.8.37-1.16.06-.26.02-.29-.32-.33v-.14h.94v.14Z"
					/>
					<path
						className="cls-4"
						d="m283.46,46.85c.62,0,1.09.48,1.09,1.12,0,.81-.6,1.2-1.09,1.2-.69,0-1.11-.56-1.11-1.12,0-.82.64-1.2,1.11-1.2Zm-.06.17c-.31,0-.58.29-.58.88,0,.64.28,1.1.69,1.1.31,0,.57-.23.57-.91,0-.59-.24-1.06-.68-1.06Zm-.17-.58l.55-.83c.13-.04.44-.04.49-.03v.07s-.93.87-.93.87l-.11-.08Z"
					/>
					<path
						className="cls-4"
						d="m289.16,48.98c-.11.02-.48.08-.78.19v-.33c-.09.06-.22.12-.31.18-.2.12-.33.15-.4.15-.4,0-.93-.4-.93-1.1s.61-1.22,1.3-1.22c.07,0,.24.01.34.06v-.74c0-.32-.04-.33-.39-.36v-.13c.25-.04.6-.1.79-.17v3.02c0,.26.03.3.22.31h.16v.15Zm-.78-1.68c-.12-.18-.33-.26-.53-.26-.24,0-.67.16-.67.88,0,.61.38.93.7.93.18,0,.38-.09.5-.18v-1.38Z"
					/>
					<path
						className="cls-4"
						d="m297.2,49.14c-.07,0-.12,0-.19,0-.37-.03-.56-.12-.78-.43-.19-.26-.37-.57-.53-.83-.1-.16-.17-.19-.42-.19h-.17v.79c0,.43.05.45.46.49v.14h-1.34v-.14c.42-.04.45-.06.45-.49v-2c0-.43-.06-.44-.45-.49v-.14h1.28c.37,0,.61.04.8.17.21.13.34.36.34.66,0,.43-.28.7-.65.86.09.16.3.49.46.72.19.27.28.39.4.52.14.15.25.2.37.23l-.02.14Zm-1.85-1.63c.26,0,.42-.04.55-.15.2-.15.28-.35.28-.62,0-.54-.36-.73-.74-.73-.15,0-.23.02-.27.05-.04.03-.06.08-.06.22v1.23h.24Z"
					/>
					<path
						className="cls-4"
						d="m301,48.68c-.32.4-.67.49-.83.49-.61,0-.98-.5-.98-1.08,0-.34.12-.66.33-.88.21-.24.49-.37.75-.37.43,0,.77.38.77.78,0,.1-.02.15-.1.17-.1.02-.74.07-1.34.08-.02.67.4.95.75.95.21,0,.39-.08.58-.26l.08.12Zm-.86-1.64c-.23,0-.46.22-.53.62.28,0,.56,0,.86-.02.09,0,.12-.02.12-.1,0-.27-.17-.51-.45-.51Z"
					/>
					<path
						className="cls-4"
						d="m303.17,47.03c.27-.04.52-.1.74-.19v1.72c0,.34-.02.55-.11.82-.18.5-.49.88-.6.98-.05.04-.09.06-.13.06-.07,0-.18-.1-.18-.23,0-.07.02-.1.08-.12.18-.05.32-.1.38-.19.06-.07.1-.18.13-.35.03-.21.04-.51.04-.97v-.99c0-.34-.03-.36-.34-.4v-.13Zm.52-.7c-.14,0-.25-.12-.25-.26,0-.16.12-.27.26-.27.13,0,.25.11.25.27,0,.14-.11.26-.25.26Z"
					/>
					<path
						className="cls-4"
						d="m308.09,48.68c-.32.4-.67.49-.83.49-.61,0-.98-.5-.98-1.08,0-.34.12-.66.33-.88.21-.24.49-.37.75-.37.43,0,.77.38.77.78,0,.1-.02.15-.1.17-.1.02-.74.07-1.34.08-.02.67.4.95.75.95.21,0,.39-.08.58-.26l.08.12Zm-.86-1.64c-.23,0-.46.22-.53.62.28,0,.56,0,.86-.02.09,0,.12-.02.12-.1,0-.27-.17-.51-.45-.51Z"
					/>
					<path
						className="cls-4"
						d="m311.53,47.5c-.09-.29-.22-.49-.53-.49-.18,0-.31.12-.31.33,0,.21.15.32.42.45.43.21.65.36.65.69,0,.46-.42.7-.82.7-.26,0-.49-.08-.6-.14-.02-.15-.07-.42-.09-.59l.15-.02c.09.32.26.58.62.58.19,0,.35-.13.35-.34,0-.23-.13-.34-.4-.47-.35-.17-.64-.33-.64-.69s.31-.65.78-.65c.21,0,.38.05.48.06.02.12.05.44.08.56l-.14.04Z"
					/>
					<path
						className="cls-4"
						d="m314.83,49.1c-.08.04-.17.06-.22.06-.32,0-.49-.2-.49-.6v-1.46h-.35l-.02-.06.13-.15h.23v-.42c.09-.1.24-.23.33-.33h.08c0,.22-.01.51-.01.75h.57c.04.05.03.16-.03.21h-.54v1.28c0,.41.16.48.29.48.12,0,.24-.04.31-.08l.04.13-.33.18Z"
					/>
					<path
						className="cls-4"
						d="m318.29,49.1h-1.15v-.14c.32-.03.35-.06.35-.38v-1.04c0-.33-.02-.35-.31-.38v-.12c.25-.04.47-.1.71-.21v.55c.17-.26.38-.54.63-.54.19,0,.29.12.29.24,0,.12-.08.23-.17.28-.05.03-.09.02-.13-.01-.08-.07-.13-.12-.22-.12-.11,0-.29.16-.4.41v.94c0,.33.02.36.41.39v.14Z"
					/>
					<path
						className="cls-4"
						d="m322.41,49.16c-.08,0-.18-.04-.24-.1-.06-.06-.09-.13-.12-.23-.2.14-.45.32-.6.32-.36,0-.61-.3-.61-.62,0-.25.14-.41.41-.5.31-.1.68-.23.79-.33v-.1c0-.36-.18-.56-.44-.56-.12,0-.19.06-.24.12-.05.07-.09.18-.13.33-.03.08-.07.12-.15.12-.09,0-.22-.1-.22-.22,0-.07.06-.13.17-.2.14-.1.44-.29.72-.35.15,0,.3.05.42.14.18.15.26.32.26.58v.97c0,.23.08.3.17.3.06,0,.12-.02.18-.05l.05.14-.43.25Zm-.37-1.27c-.11.05-.35.16-.47.21-.19.08-.3.18-.3.37,0,.27.2.39.36.39.13,0,.31-.08.41-.18v-.78Z"
					/>
					<path
						className="cls-4"
						d="m326.72,48.65c-.22.29-.56.51-.86.51-.64,0-1.01-.52-1.01-1.05,0-.4.17-.73.5-.98.27-.21.57-.29.76-.29.23,0,.39.07.47.14.07.06.08.09.08.15,0,.12-.12.23-.18.23-.02,0-.04,0-.09-.05-.16-.14-.33-.21-.5-.21-.33,0-.62.28-.62.8,0,.7.47.93.76.93.21,0,.38-.06.61-.28l.08.11Z"
					/>
					<path
						className="cls-4"
						d="m331.13,47.04c-.26.04-.32.08-.44.37-.12.28-.26.62-.61,1.49-.33.8-.42,1.11-.5,1.37-.03.11-.08.13-.15.13-.16,0-.31-.12-.31-.24,0-.06.04-.11.11-.18.16-.12.28-.25.33-.37.11-.21.18-.39.21-.45.02-.08.02-.12,0-.21-.2-.57-.47-1.19-.62-1.55-.11-.28-.16-.34-.43-.37v-.14h1.01v.14c-.23.04-.25.08-.19.27l.49,1.23c.14-.35.34-.9.45-1.22.06-.19.02-.25-.27-.29v-.14h.92v.14Z"
					/>
					<path
						className="cls-4"
						d="m333.15,47.03c.27-.04.52-.1.74-.19v1.72c0,.34-.02.55-.11.82-.18.5-.49.88-.6.98-.05.04-.09.06-.13.06-.07,0-.18-.1-.18-.23,0-.07.02-.1.08-.12.18-.05.32-.1.38-.19.06-.07.1-.18.13-.35.03-.21.04-.51.04-.97v-.99c0-.34-.03-.36-.34-.4v-.13Zm.52-.7c-.14,0-.25-.12-.25-.26,0-.16.12-.27.26-.27.13,0,.25.11.25.27,0,.14-.11.26-.25.26Z"
					/>
					<path
						className="cls-4"
						d="m337.66,49.1v-.14c.29-.03.32-.06.32-.41v-.83c0-.35-.12-.59-.46-.59-.21,0-.4.12-.56.26v1.17c0,.35.03.36.33.39v.14h-1.08v-.14c.33-.04.36-.06.36-.39v-1.03c0-.33-.04-.34-.31-.39v-.13c.25-.04.49-.1.7-.2v.4c.1-.07.21-.15.34-.23.14-.09.27-.15.42-.15.4,0,.65.3.65.78v.95c0,.34.03.36.32.39v.14h-1.04Z"
					/>
					<path
						className="cls-4"
						d="m342.89,47.04c-.26.04-.32.08-.44.37-.12.28-.26.62-.61,1.49-.33.8-.42,1.11-.5,1.37-.03.11-.08.13-.15.13-.16,0-.31-.12-.31-.24,0-.06.04-.11.11-.18.16-.12.28-.25.33-.37.11-.21.18-.39.21-.45.02-.08.02-.12,0-.21-.2-.57-.47-1.19-.62-1.55-.11-.28-.16-.34-.43-.37v-.14h1.01v.14c-.23.04-.25.08-.19.27l.49,1.23c.14-.35.34-.9.45-1.22.06-.19.02-.25-.27-.29v-.14h.92v.14Z"
					/>
				</g>
				<rect className="cls-2" x="242" y="51.97" width="102" height="20" rx="4.11" ry="4.11" />
				<path
					className="cls-4"
					d="m343.02,73.97v36.27h-99.02c.43.74,1.13,1.23,1.92,1.23h95.7c1.32,0,2.38-1.33,2.38-2.97v-33.53l-.98-1Z"
				/>
			</g>
		</svg>
	);
}

export const MemoPlaceholderRegistrationCertificateFrontPoland = React.memo(
	PlaceholderRegistrationCertificateFrontPoland
);
